<template>
  <div id="visit-card">
    <ul class="scrollList" slot="list">
      <li v-for="(item, index) of hoseList" v-bind:key="index">
        <div class="box-body van-hairline--bottom">
          <h3 v-cloak>{{item.VisitName}}</h3>
          <span class="sex-name" v-cloak>{{item.VisitStateName}}</span>
          参观时间:
          <span class="full-name" v-cloak>{{item.VisitDateTime}}</span>
        </div>
        <div class="box-footer">
          <div class="fr">
            <span class="compose" @click="editorPass(item)">查看</span>
            <!--.UserId,item.FullName,item.UserName-->
            <!-- <span class="delete" @click="delUser(item.UserId,item.FullName,index)"><yd-icon name="delete"></yd-icon>删除</span>
                                <span class="delete" @click="delWchat(item.UserId,item.FullName)">微信解绑</span>
            <span class="compose" @click="editor(item)"><yd-icon name="compose"></yd-icon>编辑</span>-->
          </div>
          <div style="clear:both"></div>
        </div>
      </li>
    </ul>

    <van-button v-if="source==='预约'" size="large" type="info" @click.native="creatVisit" class="creatBtn">预约申请</van-button>
  </div>
</template>

<script>
export default {
  components: {},
  data() {
    return {
      defaultList: []
    };
  },
  props: {
    hoseList: {
      default: []
    },
    source: {
      default: '预约'
    }
  },
  created: function() {
    this.defaultList = [...this.defaultList, ...this.hoseList];
  },
  mounted: function() {
    // console.log(this.list);
  },
  methods: {
      //查看撤销
    editorPass: function(item) {
            let loadParams = JSON.stringify(item);
        if(this.source==='预约'){
            this.$router.push({path: `/home/aboutVisit`, query:{params: 'EditState',loadParams: loadParams}});
        }else if(this.source==='审批'){
            this.$router.push({path: `/home/aboutVisit`, query:{params: 'Examine',loadParams: loadParams}});
        }
    },
    creatVisit: function() {
      this.$router.push({path: `/home/aboutVisit`, query:{params: 'Create'}});
    }

  }
};
</script>
<style lang='less' >
#visit-card {
  li {
    background: #fff;
    margin-top: 12px;
  }
  .box-body {
    border-bottom: 1px solid #eee;
    padding: 24px 20px;
    h3 {
      margin-bottom: 24px;
      font-size: 32px;
      /* font-weight: 700; */
      color: #333;
    }
    div {
      font-size: 16px;
    }
  }
  .box-footer {
    clear: both;
    padding: 20px;
    span {
      margin-left: 8px;
      padding: 20px 0;
      color: #f90;
    }
  }
  .creatBtn {
    position: fixed;
    bottom: 0;
    left: 0;
    width: 100%;
    z-index: 99;
    color: #fff;
    height: 90px;
    line-height: 90px;
    font-size: 30px;
  }
}
</style>  

